import { useEffect, useRef, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import ReportInfoCard from './components/ReportInfoCard';
import {
  BsFillCalendarCheckFill,
  BsFillCalendarEventFill,
  BsFillCalendarFill,
  BsLayoutTextSidebarReverse
} from 'react-icons/bs';
import OverallEventsTable from './components/OverallEventsTable';
import EventSummaryTable from './components/EventSummaryTable';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';
import TabNavs from '../../../../Components/TabNavs';
import DownloadBtn from '../../../../Components/Buttons/DownloadBtn';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function OverAllReport() {
  const navigate = useNavigate();
  const lang = useSelector((state) => state.local.local);

  const [summaryTableName, setSummaryTableName] = useState(null);
  const [eventsData, setEventsData] = useState([]);
  const [eventsDataStats, setEventsDataStats] = useState({});
  const [eventsSummaryData, setEventsSummaryData] = useState([]);
  const [provinceTabs, setProvinceTabs] = useState([]);
  const [loadingOverAllEvents, setLoadingOverAllEvents] = useState(true);
  const [loadingEventsSummaryData, setLoadingEventsSummaryData] = useState(true);

  useEffect(() => {
    const getEventsData = async () => {
      try {
        setLoadingOverAllEvents(true);
        const response = await fetchWrapper.get('/report/summary-report/?type=data', false, lang);
        let { data } = response.data;
        setEventsData(data);
        let provinces = data.map((data) => ({
          title: data.targeted_area
        }));
        console.log(provinces, 'provinces');
        setProvinceTabs(provinces);
        setSummaryTableName(provinces[0].title);
        setLoadingOverAllEvents(false);
      } catch (err) {
        setLoadingOverAllEvents(false);
        ErrorMessageHandler(err);
      }
    };
    getEventsData();
  }, [lang]);

  useEffect(() => {
    const getEventStatsData = async () => {
      try {
        setLoadingOverAllEvents(true);
        const response = await fetchWrapper.get('/report/stats/');
        let { data } = response.data;
        setEventsDataStats(data);
        setLoadingOverAllEvents(false);
      } catch (err) {
        setLoadingOverAllEvents(false);
        ErrorMessageHandler(err);
      }
    };
    getEventStatsData();
  }, []);

  const getEventsSummaryData = async () => {
    try {
      setLoadingEventsSummaryData(true);
      let url = `/report/province-event-list/?type=data&province=${summaryTableName}`;
      const response = await fetchWrapper.get(url);
      let { data } = response.data;
      setEventsSummaryData(data);
      setLoadingEventsSummaryData(false);
    } catch (err) {
      setLoadingEventsSummaryData(false);
      ErrorMessageHandler(err);
    }
  };
  useEffect(() => {
    if (summaryTableName) {
      getEventsSummaryData();
    }
  }, [summaryTableName]);

  const provinceTableRef = useRef();

  const handleSummaryTableNameChange = (name) => {
    provinceTableRef.current.scrollIntoView();
    setSummaryTableName(name);
  };

  const handleSummaryTableTypeChange = (type) => {
    navigate(`${type}`);
  };

  return (
    <div>
      <Row className="">
        <Col md="3">
          <ReportInfoCard
            loading={loadingOverAllEvents}
            titleId={'completedEvents'}
            count={eventsDataStats?.total_completed_events}
            Icon={BsFillCalendarCheckFill}
            iconColor="#dc3545"
            action={() => handleSummaryTableTypeChange('completed')}
          />
        </Col>
        <Col md="3">
          <ReportInfoCard
            loading={loadingOverAllEvents}
            titleId={'ongoingEvents'}
            count={eventsDataStats?.total_ongoing_events}
            Icon={BsFillCalendarEventFill}
            iconColor="#2078f9"
            action={() => handleSummaryTableTypeChange('ongoing')}
          />
        </Col>
        <Col md="3">
          <ReportInfoCard
            loading={loadingOverAllEvents}
            titleId={'upcomingEvents'}
            count={eventsDataStats?.total_upcoming_events}
            Icon={BsFillCalendarFill}
            iconColor="#198754"
            action={() => handleSummaryTableTypeChange('upcoming')}
          />
        </Col>
        <Col md="3">
          <ReportInfoCard
            loading={loadingOverAllEvents}
            titleId={'thematicAreas'}
            count={eventsDataStats?.total_thematic_areas_covered}
            Icon={BsLayoutTextSidebarReverse}
            iconColor="#1aa2b8"
          />
        </Col>
      </Row>
      <hr />
      <Row>
        <div className="col-4">
          <div className="d-flex justify-content-between mb-3">
            <h6>
              <FormattedMessage id="total_public_events" /> :
            </h6>
            <span>
              <kbd className="bg-success">{eventsDataStats?.total_public_events}</kbd>
            </span>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <h6>
              <FormattedMessage id="total_closed_events" /> :
            </h6>
            <span>
              <kbd className="bg-danger">{eventsDataStats?.total_closed_events}</kbd>
            </span>
          </div>
        </div>
      </Row>
      <Row>
        <div className="mt-3 d-flex justify-content-end">
          {/* <DownloadBtn
            type="pdf"
            apiUrl={`/report/summary-report/?type=pdf`}
          /> */}
          <DownloadBtn type="excel" apiUrl={`/report/summary-report/?type=excel`} />
        </div>
        <OverallEventsTable
          eventsData={eventsData}
          loading={loadingOverAllEvents}
          handleSummaryTableNameChange={handleSummaryTableNameChange}
        />
      </Row>
      <hr />
      <Row ref={provinceTableRef}>
        <Col>
          <TabNavs
            tabs={provinceTabs}
            activeName={summaryTableName}
            handleClick={handleSummaryTableNameChange}
            noTranslation={true}
          />
        </Col>
      </Row>
      <Row>
        <div className="mt-3 d-flex justify-content-end">
          <DownloadBtn
            type="pdf"
            apiUrl={`/report/province-event-list/?type=pdf&province=${summaryTableName}`}
          />
          <DownloadBtn
            type="excel"
            apiUrl={`/report/province-event-list/?type=excel&province=${summaryTableName}`}
          />
        </div>
        <EventSummaryTable
          eventsSummaryData={eventsSummaryData}
          loading={loadingEventsSummaryData}
          summaryTableName={summaryTableName}
        />
      </Row>
    </div>
  );
}

export default OverAllReport;
